<template>
    <div>
        <div v-if='thread_id'>
            <!-- Button trigger modal -->
            <span class="icon--message-create icon--message-create__appointments" v-on:click='showAppointmentDialog()' v-b-tooltip title="Invite for booking"></span>
        </div>

        <b-modal centered ref="appointmentDialog" title="Invite patient to book appointment" size="md">
            <div class='d-block'>
                <div class="form-row">
                    
                    <label class="col-form-label col-6">Clinician</label>
                    <select class="form-control col-18" v-model='item.staff_id'>
                        <option v-for="user in users" :key='user.id' :value='user.id' v-text='formatNameCompliant(user)'></option>
                    </select>
                </div>
                <hr>
                <div class="form-row">
                    <inline-error v-bind:errors='errors' type='appointment_type_id'></inline-error>
                    <label class="col-6">Mode</label>
                    <b-form-group class="col-18">
                        <b-form-radio-group
                        v-model="item.appointment_type_id"
                        value-field='id'
                        text-field='name'
                        :options="appointment_types"
                        plain
                        stacked
                        name="plain-stacked"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>
                <hr>
                <!-- if mode is == face to face && more than one site > show site -->
                <div v-if='$root.provider && $root.provider.site && $root.provider.site.length > 1 && (item.appointment_type_id == "1")'>
                    <div class="form-row">
                        <inline-error v-bind:errors='errors' type='site_id'></inline-error>
                        <label class="col-6">Site</label>
                        <b-form-group class="col-18">
                            <b-form-radio-group
                                stacked
                                plain
                                v-model="item.site_id"
                                name="site_id">
                                <b-form-radio class="" :disabled='!selectedClinicianHasSessionAvailability(site.id)' :value='site.id' :key='site.id' v-for='(site) in $root.provider.site'><span>{{site.name + (user && user.provider && site.id == user.provider.site_id ? " (preferred)" : "")}}</span></b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                        <inline-error type='site_id'></inline-error>
                    </div>
                    <hr>
                </div>

                <div class="form-row">
                    <inline-error v-bind:errors='errors' type='length'></inline-error>
                    <label class="col-6 col-form-label">{{ $t("translations.duration_in_minutes")}}</label>
                    <input type='number' 
                            min="0" max="720" size='8' step='1' 
                            class="form-control col-18" v-model='item.length' >
                    <!-- <select class="form-control col-18" v-model='item.length'>
                        <option disabled value="">{{$t('translations.please_select')}}</option>
                        <option v-for='length in appointment_lengths' :key='length' :value='length'>{{length}} minutes</option>
                    </select> -->
                </div>

                <hr>

                <!-- if session.length > 1 -->
                <div class="form-row">
                    <inline-error v-bind:errors='errors' type='appointment_session_type_ids'></inline-error>
                    <label class="col-6 col-form-label">Session Type</label>
                    <select multiple :select-size="4" class="form-control col-18" v-model='item.appointment_session_type_ids'>
                        <option disabled v-if='!item.staff_id'>Please select a clinician first</option>
                        <option v-else :key='session_type.id' :value='session_type.id' v-for='session_type in $root.lookup.staff.find(obj => {return this.item.staff_id == obj.id}).appointment_session_type'>{{session_type.name}}</option>
                    </select>
                </div>

            </div>

            <div slot="modal-footer" class="w-100 d-flex justify-content-between">
				<b-btn size="sm" variant="primary" v-on:click='$refs.appointmentDialog.hide()'>
					Cancel
				</b-btn>
                <b-btn size="sm" class="" variant="primary" v-on:click='sendInvite()'>
                    Invite
                </b-btn>
			</div>
		</b-modal>
    </div>
</template>

    <script>
    	export default {
    		props: {
                thread_id: null,
                user: null,
            },
    		data: function(){
    			return {
                    errors: [],
                    users: this.$root.lookup.staff,
                    item: {
                        appointment_session_type_ids: [],
                        staff_id: null,
                    },
                    site_id: '',
                    sites: this.$root.provider.site,
                    appointment_types: [],
                    selected: '',
                    appointment_lengths: [5,10,15,20,25,30,35,40,45,50,55,60],
    			};
    		},
            mounted() {
                Object.keys(this.$root.lookup.appointment_types).forEach(key => {
                    this.appointment_types.push({
                        id: key, 
                        name: this.$t("translations." + this.$root.lookup.appointment_types[key])
                    })
                });
            },
    		computed: {

    		},
    		watch: {

    		},
    		methods: {
                selectedClinicianHasSessionAvailability(site_id) {
                    if(this.users && this.item.staff_id) {
                        return this.hasSessionAvailabilityForSite(
                            this.users.find(obj => {return obj.id == this.item.staff_id}).availability_date, 
                            this.users.find(obj => {return obj.id == this.item.staff_id}).appointment_session_type, 
                            site_id);
                    }
                    return false;
                },
                showAppointmentDialog() {
                    this.item.staff_id = this.$root.user.id;
                    this.item.appointment_type_id = 1;
                    this.$refs.appointmentDialog.show();
                },
                sendInvite(invite) {
                    this.setLoading(true);
                    this.item.thread_id = this.thread_id;
                    return axios.put(this.$root.apiBase + '/appointments/invite', this.item).then((res) => {
                        this.$refs.appointmentDialog.hide();
                        this.setLoading(false);
                        this.$emit("inviteSent", this.item);    
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "create");
                    });
                            
                },
                
            }
    	}

    </script>
